<template>
<div class="panel">
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de match
        </div>
        <wizard :step="4"></wizard>
        <hr>
        <div class="panel-content" v-if="current">
                <div class="row columns">
                    <div class="large-6 columns">
                        <div class="row columns">
                            <div class="large-12 columns large-centered">
                                <div class="match-team-name">{{current.home_report.team.name}}</div>
                            </div>
                                <hr>
                            <div class="large-6 columns">
                                <img v-if="current.home_report.icon" class="team-icon-big" v-bind:src="current.home_report.icon">
                                <img v-else class="team-image" src="http://placehold.it/640x640" alt="">
                            </div>
                            <div class="large-6 columns">
                                <div class="row columns">
                                    <i class="fa fa-bed"  aria-hidden="true"></i> Autres sorties encaissées :
                                    <input type="number" min="0" step="1" placeholder="esquives, rochers..." v-model="home_other_casualties">
                                </div>
                                <div class="row columns">
                                    <i class="fa fa-money"  aria-hidden="true"></i> Gains :
                                    <input type="number" min="0" step="10000" placeholder="40000" v-model="home_winnings">
                                </div>
                                <div class="row columns">
                                    <i class="fa fa-sign-language" aria-hidden="true"></i> Pop :
                                    <select placeholder="cliquez pour choisir" name="" id="" v-model="home_fan_factor">
                                      <option value="-2">-2</option>
                                      <option value="-1">-1</option>
                                      <option value="0">0</option>
                                      <option value="1">+1</option>
                                      <option value="2">+2</option>
                                    </select>
                                </div>
                                <div class="row columns">
                                    <i class="fa fa-tv" aria-hidden="true"></i> Sponsor gagné :
                                    <select placeholder="cliquez pour choisir" name="" v-model="home_won_sponsor">
                                        <option v-bind:value="null">aucun</option>
                                        <option v-for="sp in sponsor_list" v-bind:value="sp.id">{{sp.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="large-6 columns">
                        <div class="row columns">
                            <div class="large-12 columns large-centered">
                                <div class="match-team-name">{{current.visitor_report.team.name}}</div>
                            </div>
                                <hr>
                            <div class="large-6 columns">
                                <div class="row columns">
                                    <i class="fa fa-bed"  aria-hidden="true"></i> Autres sorties encaissées :
                                    <input type="number" min="0" step="1" placeholder="esquives, rochers..." v-model="visitors_other_casualties">
                                </div>
                                <div class="row columns">
                                    <i class="fa fa-money" aria-hidden="true"></i> Gains :
                                    <input type="number" min="0" step="10000" placeholder="40000"  v-model="visitors_winnings">
                                </div>
                                <div class="row columns">
                                    <i class="fa fa-sign-language" aria-hidden="true"></i> Pop :
                                    <select placeholder="cliquez pour choisir" name="" v-model="visitors_fan_factor">
                                        <option value="-2">-2</option>
                                        <option value="-1">-1</option>
                                        <option value="0">0</option>
                                        <option value="1">+1</option>
                                        <option value="2">+2</option>
                                    </select>
                                </div>
                              <div class="row columns">
                                <i class="fa fa-tv" aria-hidden="true"></i> Sponsor gagné :
                                <select placeholder="cliquez pour choisir" name="" v-model="visitors_won_sponsor">
                                  <option v-bind:value="null">aucun</option>
                                  <option v-for="sp in sponsor_list" v-bind:value="sp.id">{{sp.name}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="large-6 columns">
                                <img v-if="current.visitor_report.icon" class="team-icon-big" v-bind:src="current.visitor_report.icon">
                                <img v-else class="team-image" src="http://placehold.it/640x640" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                    <br>
                    <div class="row columns">
                        <div v-if="error_msg" class="large-8 columns large-centered error-lbl">
                            {{error_msg}}
                        </div>
                        <br>
                    </div>
                    <div class="row columns">
                        <div class="large-2 columns large-offset-4">
                            <button  @click="previous" class="full-width light-grey-button">précédent</button>
                        </div>
                        <div class="large-2 columns end">
                            <button  @click="validate" class="full-width">Suivant</button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <spinner></spinner>
                </div>
            </div>
        </div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import { mapGetters } from 'vuex'
import teamReport from '../../api/team-report.api'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'mrStep5',
  components: {
    spinner,
    wizard,
    Datepicker
  },
  props: {
    'id': Number
  },
  data () {
    return {
      'home_winnings': null,
      'home_other_casualties': 0,
      'home_fan_factor': null,
      'home_won_sponsor': null,
      'visitors_winnings': null,
      'visitors_fan_factor': null,
      'visitors_other_casualties': 0,
      'visitors_won_sponsor': null,
      'error_msg': null,
      'mrLoaded': false,
      'sponsorLoaded': false,
      'isInit': false
    }
  },
  watch: {
    current: function (newVal, oldVal) {
      if (oldVal === null) {
        this.mrLoaded = true
        if (this.sponsorLoaded === true) {
          this.initDatas()
        }
      }
    },
    sponsor_list: function (newVal, oldVal) {
      if (oldVal.length === 0) {
        this.sponsorLoaded = true
        if (this.mrLoaded) {
          this.initDatas()
        }
      }
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser'
    ]),
    ...mapGetters({
      current: 'detailedMatchReport'
    }),
    sponsor_list: function () {
      if (this.current) {
        return this.$store.getters.sponsorListForClub(this.current.club.id)
      }
      return []
    }
  },
  methods: {
    initDatas () {
      this.home_winnings = this.current.home_report.winnings * 1000
      this.home_fan_factor = this.current.home_report.fan_factor
      this.home_other_casualties = this.current.home_report.other_casualties
      if (this.current.home_report.won_sponsor) {
        this.home_won_sponsor = this.sponsor_list.find(sp => { return sp.id === this.current.home_report.won_sponsor.id }).id
      }

      this.visitors_winnings = this.current.visitor_report.winnings * 1000
      this.visitors_fan_factor = this.current.visitor_report.fan_factor
      this.visitors_other_casualties = this.current.visitor_report.other_casualties
      if (this.current.visitor_report.won_sponsor) {
        this.visitors_won_sponsor = this.sponsor_list.find(sp => { return sp.id === this.current.visitor_report.won_sponsor.id }).id
      }
    },
    checkValid () {
      this.error_msg = ''
      if (this.home_winnings === null || this.home_winnings === '') {
        this.error_msg = 'Saisir les gains de ' + this.current.home_report.team.name
        return false
      } else if (this.home_winnings !== 0 && (this.home_winnings % 1000) !== 0) {
        this.errorsList.push('Les gains de ' + this.current.home_report.team.name + ' doivent être un multiple de 1000')
        return false
      } else if (this.home_fan_factor === null) {
        this.error_msg = 'Saisir le modificateur de fame ' + this.current.home_report.team.name
        return false
      } else if (this.visitors_winnings === null || this.visitors_winnings === '') {
        this.error_msg = 'Saisir les gains de ' + this.current.visitor_report.team.name
        return false
      } else if (this.visitors_winnings !== 0 && (this.visitors_winnings % 1000) !== 0) {
        this.errorsList.push('Les gains de ' + this.current.visitor_report.team.name + ' doivent être un multiple de 1000')
        return false
      } else if (this.visitors_fan_factor === null) {
        this.error_msg = 'Saisir le modificateur de fame ' + this.current.visitor_report.team.name
        return false
      } else {
        return true
      }
    },
    previous () {
      this.$router.push({
        name: 'mrStep3',
        params: {
          id: this.current.visitor_report.id,
          matchId: this.current.id,
          teamid: this.current.visitor_report.team.id }})
    },
    validate () {
      if (this.checkValid() === false) {
        return
      }
      // bulk update team report datas
      let trArray = []
      let homeReport = {}
      homeReport.id = this.current.home_report.id
      homeReport.winnings = this.home_winnings / 1000
      homeReport.fan_factor = this.home_fan_factor
      homeReport.other_casualties = this.home_other_casualties
      homeReport.won_sponsor = this.home_won_sponsor
      trArray.push(homeReport)

      let visitorReport = {}
      visitorReport.id = this.current.visitor_report.id
      visitorReport.winnings = this.visitors_winnings / 1000
      visitorReport.fan_factor = this.visitors_fan_factor
      visitorReport.other_casualties = this.visitors_other_casualties
      visitorReport.won_sponsor = this.visitors_won_sponsor
      trArray.push(visitorReport)

      teamReport.api.bulkUpdateTeamReport(trArray).then(
        response => {
          this.$router.push({name: 'mrStep6', params: { id: this.id }})
        },
        error => {
          this.errorsList.push(error.body.detail)
        }
      )
    }
  },
  mounted () {
    this.$store.dispatch('hideLeaguePanel')
    this.$store.dispatch('deactivateFullSizePage')
    this.$store.dispatch('invalidateDetailedMatchReport')
    this.$store.dispatch('getSponsorList')
    this.$store.dispatch('getDetailedMatchReport', this.id.toString())
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.3rem;
}
.note {
font-size:0.5rem;
}
</style>



// WEBPACK FOOTER //
// mr-step-5.vue?6295487c